import { render, staticRenderFns } from "./StandaloneApp.vue?vue&type=template&id=797dd3f9&scoped=true"
import script from "./StandaloneApp.vue?vue&type=script&lang=js"
export * from "./StandaloneApp.vue?vue&type=script&lang=js"
import style0 from "./StandaloneApp.vue?vue&type=style&index=0&id=797dd3f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797dd3f9",
  null
  
)

export default component.exports